<div *ngIf="show" class="global-loader-overlay">
  <div class="global-loader-spinner">
    <div class="loader-svg">
      <svg
        class="loader-logo-pulse"
        width="128"
        height="128"
        viewBox="0 0 1024 1024"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style="display: block"
      >
        <path
          d="M569.493 238.731C579.906 243.57 591.34 249.291 603.723 256.032C643.562 277.721 692.019 305.229 731.101 327.697C765.635 347.551 786.735 384.419 786.735 424.253V637.281C786.735 667.388 770.649 695.201 744.553 710.214L511.392 844.349C499.026 791.128 514.603 754.88 562.087 726.496C606.938 699.686 668.56 658.706 698.182 638.582C701.247 636.499 703.058 633.044 703.058 629.338V463.153C703.058 431.853 685.683 403.14 657.956 388.617L605.561 361.175C596.981 356.681 586.69 356.932 578.34 361.838L569.493 367.035V238.731ZM450.782 436.78L411.816 459.674C408.387 461.689 406.28 465.369 406.28 469.347V580.701C406.28 584.671 408.379 588.346 411.798 590.363L487.894 635.261C496.268 639.162 515.332 644.503 529.107 637.312L532.411 635.261C531.352 636.036 530.248 636.716 529.107 637.312L451.523 685.495C451.04 685.796 450.539 686.056 450.017 686.282C439.77 690.713 418.079 700.766 396.388 685.947C379.512 674.418 340.218 654.203 319.823 641.155C316.628 639.111 314.848 635.509 314.972 631.718L321.994 415.835C322.118 412.016 324.178 408.522 327.46 406.564L450.782 333.003V436.78Z"
          fill="url(#paint0_linear_646_24)"
        />
        <path
          d="M450.972 334.71L327.864 407.26C324.518 409.232 322.431 412.769 322.34 416.652C320.542 493.323 315.458 636.046 316.824 637.455C318.741 639.398 359.833 663.779 394.861 684.11C412.468 694.33 434.226 693.993 451.62 683.416L608.971 587.732C612.317 585.697 614.36 582.064 614.36 578.147V472.396C614.36 468.344 612.174 464.605 608.642 462.618L569.683 440.7V364.456L586.083 354.896C589.378 352.975 593.41 352.85 596.817 354.563L597.493 354.904C614.057 363.236 646.185 379.394 669.075 394.222C696.349 411.888 703.632 438.073 703.632 450.692L706.029 631.323C706.08 635.144 704.182 638.728 700.993 640.834L530.467 753.426C529.318 754.184 528.312 755.139 527.55 756.285C508.915 784.32 509.214 831.984 511.644 844.349C419.077 798.92 235.828 685.519 235.834 683.5C235.847 679.127 236.948 523.076 236.708 409.186C236.644 378.726 252.882 350.558 279.349 335.481L450.972 237.722V334.71Z"
          fill="url(#paint1_linear_646_24)"
        />
        <rect
          x="470.749"
          y="191.32"
          width="80.4101"
          height="299.711"
          rx="40.2051"
          fill="url(#paint2_linear_646_24)"
        />
        <circle cx="175.314" cy="347.269" r="36.5501" fill="#F9A01B" />
        <circle cx="182.625" cy="727.39" r="36.5501" fill="#F9A01B" />
        <circle cx="341.009" cy="829.731" r="19.4934" fill="#F9A01B" />
        <circle cx="682.142" cy="829.731" r="19.4934" fill="#F9A01B" />
        <circle cx="874.639" cy="534.893" r="19.4934" fill="#F9A01B" />
        <circle cx="148.511" cy="534.893" r="19.4934" fill="#F9A01B" />
        <circle cx="338.572" cy="237.617" r="19.4934" fill="#F9A01B" />
        <circle cx="682.142" cy="237.617" r="19.4934" fill="#F9A01B" />
        <circle cx="510.356" cy="107.257" r="37.7684" fill="#F9A01B" />
        <circle
          cx="503.047"
          cy="916.232"
          r="37.7684"
          transform="rotate(-180 503.047 916.232)"
          fill="#F9A01B"
        />
        <circle cx="840.525" cy="727.39" r="36.5501" fill="#F9A01B" />
        <circle cx="840.525" cy="344.833" r="36.5501" fill="#F9A01B" />
        <defs>
          <linearGradient
            id="paint0_linear_646_24"
            x1="550.762"
            y1="209.457"
            x2="550.762"
            y2="844.349"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC671" />
            <stop offset="0.43" stop-color="#F2A11F" />
            <stop offset="1" stop-color="#F9A01B" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_646_24"
            x1="471.169"
            y1="202.72"
            x2="471.169"
            y2="833.435"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#F9A01B" />
            <stop offset="0.38" stop-color="#F2A11F" />
            <stop offset="1" stop-color="#FFC671" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_646_24"
            x1="510.954"
            y1="191.32"
            x2="510.954"
            y2="491.031"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#F9A01B" />
            <stop offset="1" stop-color="#FFC671" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  </div>
</div>
